const deprecatedProps = [
  'isMobileLayout',
  'isTabletLayout',
  'isDesktopLayout',
  'isDesktopWideLayout',
  'isMobileDevice',
  'isTabletDevice',
  'isDesktopDevice',
].join(', ');

const recommendedProps = ['isMobile', 'isDesktop'].join(', ');

/** @deprecated */
export const warning = () => {
  // eslint-disable-next-line no-console
  console.warn(`LayoutContext ${deprecatedProps} are deprecated. Use ${recommendedProps} instead.`);
};
